<!-- 购物车删除||结算按钮-->
<template>
  <div class="checkout-footer-bar cart-checkout-footer">
    <div class="cart-footer-left">
      <van-checkbox
        checked-color="#ee0a24"
        :loading="submitLoading"
        v-model="checked"
        @change="handleCheckedChang"
      >全选</van-checkbox>
      <span class="checkout-footer-label">合计</span>
      <span class="checkout-footer-amount">{{ total }}</span>
    </div>
    <div
      v-if="edit"
      class="checkout-footer-btn footer-cart-action"
      :class="{ 'is-disabled': !hasSelectedItems }"
      @click="onDelete"
    >删除</div>
    <div
      v-else
      class="checkout-footer-btn footer-cart-action"
      :class="{ 'is-disabled': !hasSelectedItems }"
      @click="onSubmit"
    >结算</div>
  </div>
</template>

<script>
export default {
  name: "myCartFooter",
  props: {
    total: {
      type: Number | String,
      default: () => '0',
    },
    carData: {
      type: Array,
      default: () => [],
    },
    selectData: {
      type: Array,
    },
    type: {
      type: String,
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: false,
      submitLoading: false,
    };
  },
  computed: {
    /** 是否至少选中一条购物车行（结算 / 删除共用） */
    hasSelectedItems() {
      if (!Array.isArray(this.carData) || !this.selectData || this.selectData.length === 0) {
        return false;
      }
      return this.carData.some((el) => this.selectData.includes(el.id));
    },
  },
  methods: {
    handleCheckedChang(checked) {
      this.$emit("check", checked);
    },
    onClickEditAddress() { },
    /** 当前勾选的商品行（与结算、批量删除共用） */
    getSelectedCartItems() {
      const form = [];
      if (!Array.isArray(this.carData)) return form;
      this.carData.forEach((element) => {
        if (this.selectData && this.selectData.includes(element.id)) {
          form.push(element);
        }
      });
      return form;
    },
    async onSubmit() {
      if (!this.hasSelectedItems) return;
      const form = this.getSelectedCartItems();
      // 前端二次校验：防止页面未刷新时仍持有下架/补货中商品的勾选状态
      const unavailable = form.filter(item => item.status !== '1');
      if (unavailable.length > 0) {
        this.$Toast('部分商品已下架或补货中，请刷新购物车后重新选择');
        return;
      }
      // 购物车结算点击 判断地址是否存在，不存在需要添加地址
      const existAddressFlag = await this.getAddress();
      if (!existAddressFlag) return;
      try {
        this.submitLoading = true;
        const res = await this.$api.prepareCheckoutSnapshot(form);
        if (!res || res.code !== 0) {
          this.$Toast((res && res.msg) || '结算失败，请重试');
          return;
        }
        this.$router.push({ path: '/confirmOrder', query: { type: 1, code: res.data } });
      } catch (e) {
        this.$Toast((e && e.msg) || '网络异常，请稍后重试');
      } finally {
        this.submitLoading = false;
      }
    },
    onDelete() {
      if (!this.hasSelectedItems) return;
      this.$emit("onDelete");
    },
    change() {
      this.checked = false;
    },
    /** 获取地址 */
    async getAddress() {
      const userInfo = localStorage.getItem("userInfo");
      const userId = userInfo ? JSON.parse(userInfo).id : "";
      const resAddress = await this.$api.getAddress(userId);
      if (resAddress.code != 0) {
        this.$Toast(res.msg);
        return false;
      }
      if (Array.isArray(resAddress.data) && resAddress.data.length > 0) return true;
      this.addressTag();
      return false;
    },
    addressTag() {
      this.$Dialog.confirm({
        title: "提示",
        message: "请先设置收货地址",
        confirmButtonText: '去设置'
      }).then(() => {
        this.$router.push("/EditAddress");
      }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.checkout-footer-bar {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  min-height: 3rem;
  padding-bottom: env(safe-area-inset-bottom, 0px);
  background-color: #fff;
  box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  width: 100%;
  flex-shrink: 0;
}
.cart-footer-left {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0.35rem 0 0.35rem 0.5rem;
  gap: 0 0.35rem;
}
.checkout-footer-label { color: #666; font-size: 0.8125rem; margin-left: 0.35rem; }
.checkout-footer-amount { color: #d33b2e; font-weight: 600; font-size: 1rem; }
.checkout-footer-btn {
  flex-shrink: 0;
  width: 5.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #d33b2e;
  color: #fff;
  font-size: 0.9375rem;
  font-weight: 500;
}
.footer-cart-action.is-disabled {
  background-color: #e8e8e8;
  color: #bbb;
  pointer-events: none;
  opacity: 0.85;
}
</style>
